export const MARKETING_PAGE_PRICING_URL = 'https://www.propelio.com/pricing/'
